import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { allFilterPages } from '@features/filter/static/filterUtil';
import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const Supplier = ({ filterPageName, filterName }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setData(allData);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.SAMPLE_LIST]: dependentFilterList?.factoryList,
		[allFilterPages.MY_ORDER]: dependentFilterList?.factoryList,
		[allFilterPages.FABRIC_LIST_TAB]: dependentFilterList?.supplierList,
		[allFilterPages.COSTING_LIST]: dependentFilterList?.supplierList,
		[allFilterPages.TRIMS_LIST_TAB]: dependentFilterList?.supplierList
	};

	const onFetchData = async () => {
		let responseData = filterData[filterPageName];
		responseData = responseData?.map((item) => {
			return { id: item.id, name: item.name, ...item };
		});
		setAllData(responseData);
		setData(responseData);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allData?.filter((item) => item?.name?.toLowerCase().includes(e.target.value.toLowerCase()))
			: allData;
		setData(searchResult);
	};
	return (
		<>
			<FilterName type={filterName} />
			<Checkbox data={data} type={filterName} handleSearch={handleSearch} />
		</>
	);
};

export default Supplier;
